<template>
  <div class="wrapper">
    <Topbar />
    <LeftSidebar />

    <div class="content-page">
      <div class="content">
        <b-container fluid>
          <slot></slot>
        </b-container>
      </div>
    </div>

    <RightSidebar />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeMount, watch } from 'vue'
import { useLayoutStore } from '@/stores/layout'
import Topbar from '@/views/components/layouts/partials/topbar.vue'
import LeftSidebar from '@/views/components/layouts/partials/left-sidebar.vue'
import RightSidebar from '@/views/components/layouts/partials/right-sidebar.vue'
import router from '@/router'

export default defineComponent({
  components: { RightSidebar, LeftSidebar, Topbar },
  setup() {
    const isMenuCondensed = ref(false)
    const layoutWidth = ref('fluid')
    const useLayout = useLayoutStore()

    const toggleMenu = () => {
      document.body.classList.toggle('sidebar-enable')
    }

    const hideMenu = () => {
      document.body.classList.remove('sidebar-enable')
    }

    const toggleRightSidebar = () => {
      document.body.classList.toggle('right-bar-enabled')
    }

    const hideRightSidebar = () => {
      document.body.classList.remove('right-bar-enabled')
    }

    const activateWidth = (width: string) => {
      if (width === 'boxed') {
        document.body.setAttribute('data-layout-mode', 'boxed')
        useLayout.changeLeftbarSize('condensed')
        isMenuCondensed.value = true
      } else {
        document.body.removeAttribute('data-layout-mode')
        useLayout.changeLeftbarSize('fixed')
        isMenuCondensed.value = false
      }
    }

    onBeforeMount(() => {
      document.getElementsByTagName('html')[0]?.removeAttribute('data-layout')
      if (window.screen.width >= 767 && window.screen.width <= 1028) {
        useLayout.changeLeftbarSize('condensed')
        isMenuCondensed.value = true
      } else if (window.screen.width > 1028) {
        useLayout.changeLeftbarSize('fixed')
        isMenuCondensed.value = false
      }
      activateWidth(layoutWidth.value)
    })

    onMounted(() => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
      ) {
        if (window.screen.width >= 728 && window.screen.width <= 1028) {
          document.body.setAttribute('data-sidenav-size', 'condensed')
        }
      }
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
      ) {
        router.afterEach(() => {
          document.body.classList.remove('sidebar-enable')
        })
      }
    })

    watch(layoutWidth, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        activateWidth(newVal)
      }
    })

    return {
      isMenuCondensed,
      layoutWidth,
      toggleMenu,
      hideMenu,
      toggleRightSidebar,
      hideRightSidebar,
      activateWidth,
      useLayout,
    }
  },
})
</script>
